/* seedz-chat.js
   JS do widget de chat da Mel, extraido byte a byte do <script> inline de
   snippets/seedz-chat-widget.liquid (tema v19) para virar asset cacheavel.
   Depende de window.szChatCfg (definido inline pelo snippet ANTES deste src).
   Carregar SEM defer para manter o timing de execucao identico ao inline. */
(function(){
  'use strict';
  var root = document.getElementById('seedz-chat');
  if (!root || root.dataset.szcInit) return;
  root.dataset.szcInit = '1';

  /* ---- Config ---- */
  var API_BASE = (root.dataset.apiBase || 'https://theultron.com').replace(/\/+$/, '');
  var KEY      = (root.dataset.key || '').trim();
  var WA_NUM   = (root.dataset.wa || '').replace(/[^0-9]/g, '');
  var CID_STORE_KEY = 'seedz_chat_cid';

  /* ===== Registro total dos turnos (09/2026) =====
     O widget responde a maior parte das perguntas AQUI no navegador, e ate
     agora so o que nao casava com nenhuma camada chegava ao Ultron. Isso
     fazia o painel ver a cauda (58 turnos em tres meses) em vez do que o
     cliente de fato pergunta. Daqui pra frente todo turno e reportado, com
     a CAMADA que respondeu.

     BEST-EFFORT, SEM EXCECAO: sem `await`, com `.catch` vazio, tudo dentro
     de try/catch. Se o Ultron estiver fora do ar, o visitante nao percebe
     nada — a resposta ja foi renderizada antes desta chamada sair.

     PII: a mascara (documento, telefone, e-mail, sufixo do CEP) e aplicada
     no SERVIDOR, antes de gravar. Nao e feita aqui de proposito: uma unica
     implementacao, num lugar so, e a que da para auditar. */
  var SZ_SK_STORE_KEY = 'seedz_chat_sk';
  var SZ_SESSION_KEY = (function(){
    try{
      var k = sessionStorage.getItem(SZ_SK_STORE_KEY);
      if (!k){
        k = 'sk-' + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
        sessionStorage.setItem(SZ_SK_STORE_KEY, k);
      }
      return k;
    }catch(e){ return ''; }
  })();
  /* Estado do turno em curso. Zerado por sendMessage a cada mensagem. */
  var szTurnLayer = null, szTurnKey = null, szTurnAnswer = '', szTurnStarted = false;
  function szReportTurn(question, layer, key, answer, cid){
    try{
      if (!KEY || !question) return;
      var payload = {
        question: String(question).slice(0, 1000),
        answered_by: layer || 'outro',
        client_turn_id: 'ct-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8)
      };
      if (key) payload.answer_key = String(key).slice(0, 160);
      if (answer) payload.answer = String(answer).slice(0, 1000);
      var c = cid || getCid();
      if (c) payload.conversationId = c;
      if (SZ_SESSION_KEY) payload.session_key = SZ_SESSION_KEY;
      fetch(API_BASE + '/api/shopify/chat/turn', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Ultron-Account-Key': KEY },
        body: JSON.stringify(payload),
        keepalive: true
      }).catch(function(){});
    }catch(e){}
  }

  /* ---- Copy (verbatim) ---- */
  var GREETING = 'oi, eu sou a **Mell**, sua assistente da seedz 💙';
  var ERROR_MSG = 'ops, tive um probleminha para responder agora 😅 tenta de novo em instantes? se preferir, fala com a gente no WhatsApp.';
  var RATE_LIMIT_MSG = 'opa, hoje o movimento aqui no chat está grande e eu preciso de uma pausa 😅 me chama no WhatsApp que uma pessoa do time te responde rapidinho.';
  var HANDOFF_MARKER = '[[HANDOFF]]';

  /* ---- Order-tracking intent (client-side detect -> open the in-chat picker) ---- */
  var TRACK_KEYWORDS = [
    'rastrei', 'rastrear', 'rastreio', 'rastreamento',
    'cade meu pedido', 'cade o pedido', 'cade minha compra',
    'onde esta meu pedido', 'status do pedido', 'acompanhar pedido',
    'codigo de rastreio', 'nao chegou', 'nao recebi', 'minha entrega'
  ];
  /* strip accents + lowercase so "cadê", "não", "está" match the ascii keywords */
  function normalizeText(s){
    return String(s == null ? '' : s)
      .toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }
  function hasTrackingIntent(text){
    var n = normalizeText(text);
    if (!n) return false;
    for (var i = 0; i < TRACK_KEYWORDS.length; i++){
      if (n.indexOf(TRACK_KEYWORDS[i]) !== -1) return true;
    }
    return false;
  }

  /* ---- Recommendation intent -> run the guided quiz (not a wall-of-text) ---- */
  var RECOMMEND_KEYWORDS = [
    'recomenda', 'recomendar', 'recomende', 'recomendacao', 'indica', 'indicar', 'indique',
    'sugest', 'sugere', 'sugira', 'qual biscoito', 'que biscoito', 'qual produto',
    'qual snack', 'me ajuda a escolher', 'ajuda a escolher', 'nao sei o que', 'nao sei qual',
    'qual voce indica', 'o que voce indica', 'melhor biscoito', 'melhor cracker', 'o que comprar'
  ];
  function hasRecommendIntent(text){
    var n = normalizeText(text);
    if (!n) return false;
    for (var i = 0; i < RECOMMEND_KEYWORDS.length; i++){
      if (n.indexOf(RECOMMEND_KEYWORDS[i]) !== -1) return true;
    }
    return false;
  }

  /* ---- Greeting intent (P1) -> warm hello + quick actions (separate from help) ---- */
  function hasGreetingIntent(text){
    var n = normalizeText(text);
    if (!n) return false;
    if (n.split(' ').length > 4) return false;
    return /^(oi|ola|olá|ei|eai|e ai|opa|bom dia|boa tarde|boa noite|oi mell|ola mell)\b/.test(n);
  }

  /* ---- Help / menu intent -> re-show the tappable quick actions (not running text) ---- */
  function hasHelpIntent(text){
    var n = normalizeText(text);
    if (!n) return false;
    return /^(ajuda|menu|opcoes|opcao|comecar|comeco|inicio|voltar)\b/.test(n);
  }

  /* ---- Frete menu intent (BARE "frete") -> tappable options instead of running text.
     Narrow on purpose: specific questions ("quanto custa o frete", "frete pra 01310")
     fall through to the bot / CEP intent. ---- */
  function hasFreteMenuIntent(text){
    var n = normalizeText(text);
    if (!n) return false;
    return /^(frete|sobre o frete|sobre frete|duvida de frete|duvidas de frete|menu de frete|opcoes de frete|quero saber do frete|me fala do frete)\??$/.test(n);
  }

  /* ---- Frete grátis por região (regras da loja: Sudeste 179, demais 219, assinante 139) ---- */
  var SZ_SUDESTE_UFS = { SP:1, RJ:1, MG:1, ES:1 };
  function szFreteThreshold(uf){
    if (window._szCartHasSub) return '139';
    return SZ_SUDESTE_UFS[String(uf).toUpperCase()] ? '179' : '219';
  }
  /* CEP -> região -> limiar de frete grátis, in-chat (determinístico, via viaCEP). */
  function answerFreightForCep(cep){
    cep = String(cep).replace(/\D/g, '').slice(0, 8);
    if (cep.length !== 8) return false;
    var loading = addBotBubble('deixa eu ver para o seu CEP');
    fetch('https://viacep.com.br/ws/' + cep + '/json/')
      .then(function(r){ return r.json(); })
      .then(function(d){
        if (loading && loading.remove) loading.remove();
        if (!d || d.erro || !d.uf){
          window.__szRegion = null;
          addBotBubble('não consegui localizar esse CEP 🤔 confere os números para mim. de qualquer forma, tem frete grátis: no Sudeste a partir de R$179, nas demais regiões a partir de R$219, e quem é assinante a partir de R$139 em qualquer lugar. o valor exato aparece no checkout pelo seu CEP');
          return;
        }
        var uf = String(d.uf).toUpperCase();
        window.__szRegion = SZ_SUDESTE_UFS[uf] ? 'sudeste' : 'outras';
        var thr = szFreteThreshold(uf);
        var local = d.localidade ? (d.localidade + (d.uf ? ' (' + d.uf + ')' : '')) : uf;
        var frase = window._szCartHasSub
          ? ('como você tem assinatura, o frete fica grátis a partir de R$139')
          : ('o frete fica grátis a partir de R$' + thr + ' (assinante tem grátis a partir de R$139 em qualquer região)');
        addBotBubble('para o seu CEP, em ' + local + ', ' + frase + '. o valor exato aparece no checkout quando você põe os produtos no carrinho.');
      })
      .catch(function(){
        if (loading && loading.remove) loading.remove();
        addBotBubble('tive um probleminha para checar esse CEP agora 😅 mas o valor do frete sempre aparece no checkout pelo seu CEP. tem frete grátis: Sudeste a partir de R$179, demais regiões R$219, assinante R$139 em qualquer lugar');
      });
    return true;
  }

  /* ---- DOM refs ---- */
  var panel    = root.querySelector('#szc-panel');
  var backdrop = root.querySelector('[data-szc-backdrop]');
  var bodyEl   = root.querySelector('[data-szc-body]');
  var input    = root.querySelector('[data-szc-input]');
  var sendBtn  = root.querySelector('[data-szc-send]');
  var toggleBtn= root.querySelector('[data-szc-toggle]');

  /* ---- State ---- */
  var isOpen = false;
  var inFlight = false;
  var greeted = false;
  var lastFocus = null;

  function getCid(){ try { return sessionStorage.getItem(CID_STORE_KEY) || ''; } catch(e){ return ''; } }
  function setCid(v){ try { if (v) sessionStorage.setItem(CID_STORE_KEY, v); } catch(e){} }

  /* ===== HTML escaping (XSS-safe) ===== */
  function escapeHtml(s){
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* ===== Minimal, SAFE markdown -> HTML =====
     Operates on already-escaped text, so no raw HTML can survive.
     Supports: **bold**, *italic*, `code`->plain, --- separators,
     - / * bullet lists, blank-line paragraphs, and [text](http...) links. */
  function renderInline(escaped){
    var out = escaped;
    /* links: [label](http... | /caminho) ; url already escaped. Allows http/https
       plus root-relative store paths (ex.: /pages/onde-encontrar). External opens
       a new tab; store paths navigate in the same tab. */
    out = out.replace(/\[([^\]]+)\]\(((?:https?:\/\/|\/)[^\s)]+)\)/g, function(m, label, url){
      var ext = /^https?:\/\//i.test(url);
      return '<a href="' + url + '"' + (ext ? ' target="_blank" rel="noopener noreferrer"' : '') + '>' + label + '</a>';
    });
    /* bold then italic (bold first so ** isn't eaten by *) */
    out = out.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    out = out.replace(/(^|[^*])\*([^*\n]+)\*/g, '$1<em>$2</em>');
    /* inline code -> strip backticks, keep text */
    out = out.replace(/`([^`]+)`/g, '$1');
    return out;
  }
  function renderMarkdown(text){
    var escaped = escapeHtml(text).replace(/\r\n/g, '\n');
    var lines = escaped.split('\n');
    var html = '';
    var inList = false;
    var para = [];
    function flushPara(){
      if (!para.length) return;
      html += '<p>' + renderInline(para.join('<br>')) + '</p>';
      para = [];
    }
    function closeList(){ if (inList){ html += '</ul>'; inList = false; } }
    for (var i = 0; i < lines.length; i++){
      var line = lines[i];
      var trimmed = line.trim();
      if (trimmed === ''){ flushPara(); closeList(); continue; }
      /* horizontal rule */
      if (/^(---+|\*\*\*+|___+)$/.test(trimmed)){ flushPara(); closeList(); html += '<hr>'; continue; }
      /* heading (# .. ######) -> styled title; strip the # so it never shows literally */
      var hd = trimmed.match(/^#{1,6}\s+(.*)$/);
      if (hd){ flushPara(); closeList(); html += '<div class="szc-mh">' + renderInline(hd[1]) + '</div>'; continue; }
      /* markdown table row -> clean attribute row; skip separator (|---|) and empty (| |) rows */
      if (/^\|.*\|$/.test(trimmed)){
        flushPara(); closeList();
        if (/^\|[\s:|-]*\|$/.test(trimmed)) continue;
        var cells = trimmed.replace(/^\||\|$/g, '').split('|').map(function(c){ return c.trim(); }).filter(function(c){ return c.length; });
        if (!cells.length) continue;
        html += '<div class="szc-trow">';
        for (var ci = 0; ci < cells.length; ci++){ html += '<span>' + renderInline(cells[ci]) + '</span>'; }
        html += '</div>';
        continue;
      }
      /* list item */
      var li = trimmed.match(/^[-*•]\s+(.*)$/);
      if (li){
        flushPara();
        if (!inList){ html += '<ul>'; inList = true; }
        html += '<li>' + renderInline(li[1]) + '</li>';
        continue;
      }
      closeList();
      para.push(line);
    }
    flushPara(); closeList();
    return html || '<p>' + renderInline(escaped) + '</p>';
  }

  /* ===== Bubble builders ===== */
  function scrollDown(){ bodyEl.scrollTop = bodyEl.scrollHeight; }

  function addUserBubble(text){
    var el = document.createElement('div');
    el.className = 'szc-msg szc-msg-user';
    el.textContent = text; /* user text never parsed as markdown */
    bodyEl.appendChild(el);
    scrollDown();
  }
  function addBotBubble(text){
    /* Registro total: guarda o que a Mell respondeu neste turno. So a
       PRIMEIRA bolha entra de forma garantida — streamBotBubbles solta as
       seguintes por setTimeout, depois de sendMessage ja ter reportado. E
       previa, nao transcricao, entao a primeira basta. */
    try{ szTurnAnswer = szTurnAnswer ? (szTurnAnswer + ' ' + text) : String(text == null ? '' : text); }catch(e){}
    var el = document.createElement('div');
    el.className = 'szc-msg szc-msg-bot';
    el.innerHTML = renderMarkdown(text);
    bodyEl.appendChild(el);
    scrollDown();
    return el;
  }

  /* ===== Multi-bubble: split ONE reply into separate chat bubbles =====
     dg: "cada mensagem deveria ter sua própria bubble". We split on blank
     lines (paragraph boundaries — lists stay intact, joined by single \n) and
     reveal each segment as its own bot bubble with a short typing pause between,
     so a long answer reads like several natural messages instead of a wall. */
  function splitIntoMessages(text){
    var norm = String(text == null ? '' : text).replace(/\r\n/g, '\n').replace(/\n{3,}/g, '\n\n').trim();
    if (!norm) return [];
    var clean = [];
    var parts = norm.split(/\n\n+/);
    /* keep only chunks with real text — drops table separators (|---|) / stray pipes
       that would otherwise render as a hollow bubble */
    for (var i = 0; i < parts.length; i++){ var s = parts[i].trim(); if (s && /[0-9A-Za-zÀ-ÿ]/.test(s.replace(/\|/g, ' '))) clean.push(s); }
    /* Merge a heading/title-only chunk into the next one so it never renders as a
       hollow bubble ("# título" sozinho). Keeps headings attached to their text. */
    var segs = [];
    for (var k = 0; k < clean.length; k++){
      var seg = clean[k];
      var titleOnly = (seg.indexOf('\n') === -1) &&
                      (/^#{1,6}\s+\S/.test(seg) || /^\*\*[^*]+\*\*[.:]?$/.test(seg));
      if (titleOnly && k < clean.length - 1){ segs.push(seg + '\n' + clean[k + 1]); k++; }
      else { segs.push(seg); }
    }
    return segs;
  }
  function streamBotBubbles(text, onDone){
    var segs = splitIntoMessages(text);
    if (!segs.length){ hideTyping(); if (onDone) onDone(null); return; }
    var lastEl = null, i = 0;
    function step(){
      hideTyping();
      lastEl = addBotBubble(segs[i]); i++;
      if (i < segs.length){
        showTyping();
        var d = Math.min(900, 350 + segs[i - 1].length * 7);
        setTimeout(step, d);
      } else {
        if (onDone) onDone(lastEl);
      }
    }
    step();
  }

  /* ===== Typing indicator ===== */
  var typingEl = null;
  function showTyping(){
    if (typingEl) return;
    typingEl = document.createElement('div');
    typingEl.className = 'szc-typing';
    typingEl.setAttribute('aria-label', 'digitando');
    typingEl.innerHTML = '<span></span><span></span><span></span>';
    bodyEl.appendChild(typingEl);
    scrollDown();
  }
  function hideTyping(){ if (typingEl){ typingEl.remove(); typingEl = null; } }

  /* ===== WhatsApp icon markup ===== */
  var WA_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>';

  /* Reveal a "Falar no WhatsApp" action. mode 'handoff' = API summary handoff; 'fallback' = direct wa.me */
  function addHandoffButton(mode){
    /* avoid stacking duplicate buttons */
    var existing = bodyEl.querySelector('.szc-handoff[data-mode="' + mode + '"]');
    if (existing) return;
    var wrap = document.createElement('div');
    wrap.className = 'szc-handoff';
    wrap.setAttribute('data-mode', mode);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'szc-handoff-btn';
    btn.innerHTML = WA_ICON + '<span>Falar no WhatsApp</span>';
    btn.addEventListener('click', function(){
      if (mode === 'handoff'){ doHandoff(btn); }
      else { openDirectWhatsApp(); }
    });
    wrap.appendChild(btn);
    bodyEl.appendChild(wrap);
    scrollDown();
  }

  /* W1d: resumo client-side da conversa (últimas falas) pro handoff no WhatsApp */
  function szBuildSummary(){
    try{
      var nodes = bodyEl.querySelectorAll('.szc-msg-user, .szc-msg-bot');
      var lines = [];
      for (var i = 0; i < nodes.length; i++){
        var n = nodes[i];
        if (n.querySelector && n.querySelector('.szc-order-card')) continue;
        var who = n.classList.contains('szc-msg-user') ? 'Cliente' : 'Mell';
        var t = (n.textContent || '').replace(/\s+/g, ' ').trim();
        if (t) lines.push(who + ': ' + t);
      }
      lines = lines.slice(-8);
      var s = lines.join('\n');
      if (s.length > 700) s = '...' + s.slice(-700);
      return s;
    }catch(e){ return ''; }
  }
  /* W1-log: registra perguntas sem resposta (App Proxy) — falha em silêncio */
  function szLogUnanswered(q){
    try{
      fetch('/apps/reviews/log-question', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ question: String(q || '').slice(0, 1000) }),
        keepalive: true
      }).catch(function(){});
    }catch(e){}
  }
  function openDirectWhatsApp(){
    var num = WA_NUM || '5521967671203';
    var summary = szBuildSummary();
    var txt = 'Oi! Vim pelo chat da Mell no site da seedz e queria falar com uma pessoa do time.' + (summary ? ('\n\nNossa conversa:\n' + summary) : '');
    var url = 'https://wa.me/' + num + '?text=' + encodeURIComponent(txt);
    try { window.open(url, '_blank', 'noopener'); } catch(e){ window.location.href = url; }
  }

  /* ===== Region-aware frete highlight (additive, client-side) =====
     When the bot's reply lists all 3 free-shipping tiers (detected by both
     "R$179" and "R$219" appearing in the text) AND the theme exposed the
     visitor's region in window.__szRegion, append a single short helper line
     under the bubble pointing at the tier that applies to THEM:
       sudeste -> R$179 · other regions -> R$219 · subscription cart -> R$139.
     If __szRegion is undefined we do nothing (the bot already stated all 3). */
  function maybeAppendRegionFrete(replyText, bubbleEl){
    try {
      if (!replyText || !bubbleEl) return;
      var region = window.__szRegion;
      if (!region) return; /* no region signal -> leave the bot's full answer as-is */

      /* require both anchor tiers in the reply (tolerate "R$ 179" / "R$179") */
      var compact = String(replyText).replace(/\s+/g, '');
      if (compact.indexOf('R$179') === -1 || compact.indexOf('R$219') === -1) return;

      var hasSub = (window._szCartHasSub === true);
      var amount = hasSub ? '139' : (normalizeText(region) === 'sudeste' ? '179' : '219');

      var note = document.createElement('div');
      note.className = 'szc-region-note';
      var msg = hasSub
        ? 'com a assinatura no carrinho, o frete grátis é a partir de R$' + amount
        : 'para a sua região, o frete grátis é a partir de R$' + amount;
      note.textContent = msg;

      /* place the helper line right after the bot bubble */
      if (bubbleEl.parentNode){
        if (bubbleEl.nextSibling) bubbleEl.parentNode.insertBefore(note, bubbleEl.nextSibling);
        else bubbleEl.parentNode.appendChild(note);
      } else {
        bodyEl.appendChild(note);
      }
      scrollDown();
    } catch(e){ /* purely additive — never break the chat */ }
  }

  /* ===== Quick-action chips (rendered in the stream, greeting only) ===== */
  /* Opening quick-reply menu — 4 tappable chips that lift task completion.
     Each chip either (a) sends a message through the normal bot flow, or
     (b) runs a local action (order picker / WhatsApp handoff). */
  /* Dúvidas menu -> client-side tappable options (no bot round-trip) */
  function openDuvidas(){
    addBotBubble('me conta um pouco sobre sua dúvida 🙂 se não estiver nas opções abaixo, é só escrever que eu te entendo.');
    addOptionChips(['Frete', 'Validade', 'Vegano']);
  }

  function addQuickActions(){
    try {
      /* dedupe: drop any existing quick-action row so "ajuda"/"oi"/"menu" never stacks duplicate chips */
      var __szcOld = document.querySelectorAll('.szc-chips');
      for (var __k = 0; __k < __szcOld.length; __k++){ if (__szcOld[__k].parentNode) __szcOld[__k].parentNode.removeChild(__szcOld[__k]); }
      var ACTIONS = [
        { emoji: '🍪',
          img: 'https://cdn.shopify.com/s/files/1/0588/6971/0944/files/seedz-caixa-mista-card.avif?v=1790608999&width=96',
          label: 'Recomende um biscoito',        aria: 'Recomende um biscoito',
          run: function(){ startQuiz(); } },
        { emoji: '📦', label: 'Quero rastrear meu pedido',     aria: 'Quero rastrear meu pedido',
          run: function(){ openOrderPicker(); } },
        { emoji: '❓', label: 'Dúvidas', aria: 'Tirar uma dúvida',
          run: function(){ openDuvidas(); } },
        { emoji: '💬', label: 'Falar com a gente',             aria: 'Falar com a gente no WhatsApp',
          run: function(){ doHandoff(); } }
      ];

      var wrap = document.createElement('div');
      wrap.className = 'szc-chips';

      ACTIONS.forEach(function(a){
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'szc-chip' + (a.img ? ' szc-chip--img' : '');
        var ic;
        if (a.img) {
          ic = document.createElement('img');
          ic.className = 'szc-chip-thumb';
          ic.alt = ''; ic.setAttribute('aria-hidden', 'true'); ic.decoding = 'async';
          /* webp blob fetch (avoids the avif <img> negotiation); emoji fallback */
          (function(im, src, emoji){
            function toEmoji(){ var em = document.createElement('span'); em.setAttribute('aria-hidden', 'true'); em.textContent = emoji; if (im.parentNode) im.parentNode.replaceChild(em, im); }
            fetch(src, { headers: { 'Accept': 'image/webp,image/png,image/jpeg,image/*' } })
              .then(function(r){ if (!r.ok) throw 0; return r.blob(); })
              .then(function(b){ im.src = URL.createObjectURL(b); })
              .catch(function(){ im.loading = 'eager'; im.addEventListener('error', toEmoji); im.src = src; });
          })(ic, a.img, a.emoji);
        } else {
          ic = document.createElement('span'); ic.setAttribute('aria-hidden', 'true'); ic.textContent = a.emoji;
        }
        var tx = document.createElement('span'); tx.textContent = a.label;
        chip.appendChild(ic); chip.appendChild(tx);
        chip.setAttribute('aria-label', a.aria);
        chip.addEventListener('click', function(){
          /* chips are a one-shot greeting menu: remove the whole row on tap so
             it doesn't clutter the stream, then run the action */
          if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
          try { a.run(); } catch(e){}
        });
        wrap.appendChild(chip);
      });

      bodyEl.appendChild(wrap);
      scrollDown();
    } catch(e){ /* chips are non-critical — never break the chat */ }
  }

  /* ===== In-chat order picker ===== */

  /* Detect the type of the "outro dado" field and return {field, value} for the API. */
  function detectSecondFactor(raw){
    var v = (raw || '').trim();
    if (!v) return null;
    if (v.indexOf('@') !== -1) return { field: 'email', value: v };
    if (v.charAt(0) === '#') return { field: 'order_number', value: v };
    var digits = v.replace(/\D/g, '');
    if (digits) {
      if (digits.length === 8) return { field: 'cep', value: digits };
      if (digits.length >= 10 && digits.length <= 13) return { field: 'phone', value: digits };
    }
    return { field: 'order_number', value: v };
  }

  /* Harden an input against browser/password-manager autofill (the "box roxo"). */
  function szcHardenInput(el){
    try{
      el.setAttribute('autocomplete', 'off');
      el.setAttribute('autocorrect', 'off');
      el.setAttribute('autocapitalize', 'off');
      el.setAttribute('spellcheck', 'false');
      el.setAttribute('data-form-type', 'other');
      el.setAttribute('data-1p-ignore', '');
      el.setAttribute('data-lpignore', 'true');
      el.setAttribute('data-bwignore', '');
    }catch(e){}
  }

  /* Re-assert a clean (white) background so an extension/autofill can't tint the field. */
  function szcGuardInputTint(el){
    function fix(){
      try{
        if (el.style.backgroundColor !== 'rgb(255, 255, 255)') el.style.setProperty('background-color', '#fff', 'important');
        if (el.style.backgroundImage !== 'none') el.style.setProperty('background-image', 'none', 'important');
      }catch(e){}
    }
    fix();
    el.addEventListener('focus', fix);
    el.addEventListener('blur', fix);
    try{ new MutationObserver(fix).observe(el, { attributes:true, attributeFilter:['style'] }); }catch(e){}
  }

  /* Mascara de CPF progressiva: 000.000.000-00 (so digitos, max 11). */
  function szcMaskCPF(v){
    var d = (v || '').replace(/\D/g, '').slice(0, 11);
    if (d.length > 9) return d.slice(0,3)+'.'+d.slice(3,6)+'.'+d.slice(6,9)+'-'+d.slice(9);
    if (d.length > 6) return d.slice(0,3)+'.'+d.slice(3,6)+'.'+d.slice(6);
    if (d.length > 3) return d.slice(0,3)+'.'+d.slice(3);
    return d;
  }

  /* Render the picker form as a bot-side card. opts.focus = 'cpf' | 'second' to steer the cursor. */
  function openOrderPicker(opts){
    opts = opts || {};
    if (!isOpen) openPanel();

    var wrap = document.createElement('div');
    wrap.className = 'szc-msg szc-msg-bot';

    var intro = document.createElement('p');
    intro.style.margin = '0';
    intro.innerHTML = 'Para achar seu pedido, me passa seu <strong>CPF</strong> + mais um dado (e-mail, telefone, n&ordm; do pedido ou CEP).';

    var form = document.createElement('form');
    form.className = 'szc-order-form';
    form.setAttribute('novalidate', 'novalidate');
    form.autocomplete = 'off';

    /* CPF field */
    var f1 = document.createElement('div'); f1.className = 'szc-of-field';
    var cpf = document.createElement('input');
    cpf.type = 'text'; cpf.className = 'szc-of-input';
    cpf.setAttribute('inputmode', 'numeric');
    cpf.placeholder = 'Seu CPF';
    cpf.setAttribute('aria-label', 'Seu CPF');
    cpf.autocomplete = 'off'; cpf.maxLength = 14;
    szcHardenInput(cpf); szcGuardInputTint(cpf);
    f1.appendChild(cpf);

    /* Second-factor field */
    var f2 = document.createElement('div'); f2.className = 'szc-of-field';
    var snd = document.createElement('input');
    snd.type = 'text'; snd.className = 'szc-of-input';
    snd.placeholder = 'E-mail, telefone, nº do pedido ou CEP';
    snd.setAttribute('aria-label', 'E-mail, telefone, número do pedido ou CEP');
    snd.autocomplete = 'off'; snd.maxLength = 80;
    szcHardenInput(snd); szcGuardInputTint(snd);
    f2.appendChild(snd);

    var hint = document.createElement('p');
    hint.className = 'szc-of-hint';
    hint.id = 'szc-of-hint-' + Date.now();
    hint.setAttribute('role', 'alert');

    var submit = document.createElement('button');
    submit.type = 'submit'; submit.className = 'szc-of-submit';
    submit.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg><span>Buscar meus pedidos</span>';

    form.appendChild(f1);
    form.appendChild(f2);
    form.appendChild(hint);
    form.appendChild(submit);

    wrap.appendChild(intro);
    wrap.appendChild(form);
    var trust = document.createElement('p');
    trust.className = 'szc-of-trust';
    trust.innerHTML = '<span class="szc-of-lock" aria-hidden="true">🔒</span><span>Usamos só para localizar seu pedido.<br>Seus dados ficam seguros.</span>';
    wrap.appendChild(trust);
    bodyEl.appendChild(wrap);
    scrollDown();

    function showHint(msg, field){
      hint.textContent = msg;
      hint.classList.add('szc-of-show');
      cpf.classList.toggle('szc-of-invalid', field === 'cpf' || field === 'both');
      snd.classList.toggle('szc-of-invalid', field === 'second' || field === 'both');
    }
    function clearHint(){
      hint.classList.remove('szc-of-show');
      cpf.classList.remove('szc-of-invalid');
      snd.classList.remove('szc-of-invalid');
    }
    cpf.addEventListener('input', function(){ cpf.value = szcMaskCPF(cpf.value); clearHint(); });
    snd.addEventListener('input', clearHint);

    function handleSubmit(){
      if (inFlight) return;
      var cpfVal = cpf.value.replace(/\D/g, '');
      var sndVal = snd.value.trim();
      if (!cpfVal && !sndVal){ showHint('preenche os dois campos para eu buscar', 'both'); cpf.focus(); return; }
      if (!cpfVal){ showHint('preciso do seu CPF', 'cpf'); cpf.focus(); return; }
      if (!sndVal){ showHint('me passa mais um dado: e-mail, telefone, nº do pedido ou CEP', 'second'); snd.focus(); return; }
      clearHint();
      /* lock + visually mark this form as submitted */
      cpf.disabled = true; snd.disabled = true; submit.disabled = true;
      form.style.opacity = '.7';
      lookupOrders(cpfVal, sndVal);
    }

    form.addEventListener('submit', function(e){ e.preventDefault(); handleSubmit(); });
    /* Enter on either input submits (inputs are not inside a multiline control, but be explicit) */
    function enterSubmit(e){ if (e.key === 'Enter'){ e.preventDefault(); handleSubmit(); } }
    cpf.addEventListener('keydown', enterSubmit);
    snd.addEventListener('keydown', enterSubmit);

    /* focus the requested field (default: CPF) */
    setTimeout(function(){
      try { (opts.focus === 'second' ? snd : cpf).focus({ preventScroll: true }); }
      catch(e){ (opts.focus === 'second' ? snd : cpf).focus(); }
    }, 60);
  }

  /* POST {cpf, <detected second factor>} to the lookup endpoint. */
  function lookupOrders(cpfVal, sndVal){
    setInFlight(true);
    /* removable "buscando…" loading bubble (replaced by the result) */
    var loadingEl = addBotBubble('buscando seus pedidos…');
    showTyping();

    var sf = detectSecondFactor(sndVal);
    var payload = { cpf: cpfVal };
    if (sf && sf.value) payload[sf.field] = sf.value;

    function clearLoading(){ hideTyping(); if (loadingEl){ loadingEl.remove(); loadingEl = null; } }

    /* W1e: App Proxy (Projeto Reviews) — HMAC assinado pela Shopify, sem key no tema */
    fetch('/apps/reviews/order-lookup', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function(res){
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    })
    .then(function(data){
      clearLoading();
      renderOrderResults(data || {});
    })
    .catch(function(){
      clearLoading();
      addBotBubble('tive um probleminha para buscar agora 😅 pode tentar de novo aqui embaixo, ou me chama no WhatsApp.');
      addHandoffButton('fallback');
      openOrderPicker({ focus: 'cpf' });
    })
    .then(function(){ setInFlight(false); });
  }

  /* Friendly pt-BR date from an ISO/string timestamp. Returns '' if unparseable. */
  function friendlyDate(raw){
    if (!raw) return '';
    var d = new Date(raw);
    if (isNaN(d.getTime())) return '';
    try {
      return d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' });
    } catch(e){
      return d.toLocaleDateString();
    }
  }

  /* Map tracking_state -> {label, cssClass} for the status chip (accent/casing tolerant). */
  function trackingChip(state){
    switch (normalizeText(state)){
      case 'a caminho': return { label: 'a caminho', cls: 'szc-oc-ontheway' };
      case 'enviado':   return { label: 'enviado', cls: 'szc-oc-shipped' };
      case 'ainda nao enviado': return { label: 'ainda não enviado', cls: 'szc-oc-pending' };
      default: return null;
    }
  }

  /* Render the backend response in-chat. */
  function renderOrderResults(data){
    if (data.found === true && Array.isArray(data.orders) && data.orders.length){
      addBotBubble('achei seus pedidos! toque no que você quer acompanhar:');
      renderOrderCards(data.orders);
      return;
    }
    /* found:false branches */
    if (data.need_cpf === true){
      addBotBubble('preciso do seu CPF para confirmar que o pedido é seu');
      openOrderPicker({ focus: 'cpf' });
      return;
    }
    if (data.need_second_factor === true){
      addBotBubble('me passa mais um dado: e-mail, telefone, nº do pedido ou CEP.');
      openOrderPicker({ focus: 'second' });
      return;
    }
    /* generic not-found: deixa a pessoa redigitar (não trava o formulário) */
    addBotBubble('não localizei nenhum pedido com esses dados 🤔 confere o CPF e o outro dado, às vezes tem um detalhe diferente. pode tentar de novo aqui embaixo');
    addHandoffButton('fallback');
    openOrderPicker({ focus: 'cpf' });
  }

  function renderOrderCards(orders){
    var wrap = document.createElement('div');
    wrap.className = 'szc-orders';
    var max = Math.min(orders.length, 3);
    for (var i = 0; i < max; i++){
      wrap.appendChild(buildOrderCard(orders[i]));
    }
    bodyEl.appendChild(wrap);
    scrollDown();
  }

  /* Does this order's financial status read as "payment still pending"? */
  function isPendingPayment(order){
    var n = normalizeText(order && order.financial_status_ptbr);
    if (!n) return false;
    return n.indexOf('aguardando pagamento') !== -1 ||
           n.indexOf('pendente') !== -1 ||
           n.indexOf('aguardando') !== -1;
  }

  function buildOrderCard(order){
    order = order || {};
    var card = document.createElement('button');
    card.type = 'button';
    card.className = 'szc-order-card';

    var url = order.rastreamento_url;
    var hasUrl = !!(url && /^https?:\/\//i.test(String(url)));
    /* "finalizar pagamento" only makes sense for PIX: on card the bank
       authorizes after checkout and the customer does nothing. So the pending
       treatment fires ONLY for a pending order that is Pix (is_pix from the
       backend). A pending card order just shows its normal status. */
    var pending = isPendingPayment(order) && order.is_pix === true;
    if (pending) card.classList.add('szc-oc-pending-card');

    var num = order.order_number ? String(order.order_number) : 'Pedido';
    if (num.charAt(0) !== '#') num = '#' + num.replace(/^#*/, '');
    var dateTxt = friendlyDate(order.placed_at);

    /* status line: prefer fulfillment, then financial */
    var statusBits = [];
    if (order.fulfillment_status_ptbr) statusBits.push(String(order.fulfillment_status_ptbr));
    if (order.financial_status_ptbr) statusBits.push(String(order.financial_status_ptbr));
    var statusLine = statusBits.join(' · ');

    var chip = trackingChip(order.tracking_state);

    /* ---- top row: number + date ---- */
    var top = document.createElement('div'); top.className = 'szc-oc-top';
    var numEl = document.createElement('span'); numEl.className = 'szc-oc-num'; numEl.textContent = num;
    top.appendChild(numEl);
    if (dateTxt){
      var dateEl = document.createElement('span'); dateEl.className = 'szc-oc-date'; dateEl.textContent = dateTxt;
      top.appendChild(dateEl);
    }
    card.appendChild(top);

    /* ---- status line ---- */
    if (statusLine){
      var st = document.createElement('div'); st.className = 'szc-oc-status'; st.textContent = statusLine;
      card.appendChild(st);
    }

    /* ---- itens do pedido: imagem + nome + quantidade (privacidade: nome/qtd + imagem publica do produto, nunca preco/PII) ---- */
    if (Array.isArray(order.items) && order.items.length){
      var itemsEl = document.createElement('div');
      itemsEl.className = 'szc-oc-items';
      for (var k = 0; k < order.items.length && k < 12; k++){
        var it = order.items[k] || {};
        var nm = (it.title || it.name || '').toString().trim();
        if (!nm) continue;
        var qty = parseInt(it.quantity, 10); if (!(qty > 0)) qty = 1;
        var irow = document.createElement('div'); irow.className = 'szc-oci-row';
        var iimg = document.createElement('img'); iimg.className = 'szc-oci-img'; iimg.alt = ''; iimg.setAttribute('aria-hidden', 'true');
        if (it.image_url){
          var iurl = String(it.image_url); iurl = iurl + (iurl.indexOf('?') !== -1 ? '&' : '?') + 'width=120';
          attachProdImg(iimg, iurl);
        } else { iimg.classList.add('szc-loaded'); }
        var inm = document.createElement('span'); inm.className = 'szc-oci-name'; inm.textContent = nm;
        var iqt = document.createElement('span'); iqt.className = 'szc-oci-qty'; iqt.textContent = qty + 'x';
        irow.appendChild(iimg); irow.appendChild(inm); irow.appendChild(iqt);
        itemsEl.appendChild(irow);
      }
      if (itemsEl.children.length) card.appendChild(itemsEl);
    }

    /* ---- foot: tracking chip + CTA ---- */
    var foot = document.createElement('div'); foot.className = 'szc-oc-foot';
    if (chip){
      var chipEl = document.createElement('span'); chipEl.className = 'szc-oc-chip ' + chip.cls; chipEl.textContent = chip.label;
      foot.appendChild(chipEl);
    } else {
      foot.appendChild(document.createElement('span')); /* spacer keeps CTA right-aligned */
    }
    var go = document.createElement('span'); go.className = 'szc-oc-go';
    if (hasUrl){
      go.innerHTML = '<span>Acompanhar</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><polyline points="9 18 15 12 9 6"/></svg>';
    } else {
      go.innerHTML = '<span>Ver status</span>';
    }
    foot.appendChild(go);
    card.appendChild(foot);

    /* ---- pending-payment action: "finalizar pagamento" -> WhatsApp handoff ----
       Nested as a role=button span (a <button> inside <button> is invalid HTML);
       stops propagation so it doesn't also fire the card's main click. */
    if (pending){
      var pay = document.createElement('span');
      pay.className = 'szc-oc-pay';
      pay.setAttribute('role', 'button');
      pay.setAttribute('tabindex', '0');
      pay.setAttribute('aria-label', 'Finalizar pagamento do ' + num + ' pelo WhatsApp');
      pay.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/></svg><span>finalizar pagamento</span>';
      var doPay = function(ev){
        if (ev){ ev.preventDefault(); ev.stopPropagation(); }
        addBotBubble('te ajudo a finalizar o pagamento do ' + num + ' me chama no WhatsApp que a gente reenvia o Pix para você.');
        addHandoffButton('fallback');
      };
      pay.addEventListener('click', doPay);
      pay.addEventListener('keydown', function(ev){
        if (ev.key === 'Enter' || ev.key === ' '){ doPay(ev); }
      });
      card.appendChild(pay);
    }

    if (hasUrl){
      card.setAttribute('aria-label', 'Acompanhar ' + num);
      card.addEventListener('click', function(){
        try { window.open(url, '_blank', 'noopener'); } catch(e){ window.location.href = url; }
      });
    } else {
      card.setAttribute('aria-label', num + ' — ver status');
      card.addEventListener('click', function(){
        addBotBubble('esse ainda não tem código de rastreio; me chama no WhatsApp que eu confirmo');
        addHandoffButton('fallback');
      });
    }
    return card;
  }

  /* ===== Guided recommendation quiz (tappable steps) =====
     dg: when asked to recommend, ask via a tap-quiz with embedded questions,
     not one big text. Each answer is a bubble; the end renders product cards. */
  var QUIZ_STEPS = [
    { key: 'tipo',
      q: 'perfeito! deixa eu te ajudar a escolher primeiro: você prefere algo doce ou salgado?',
      opts: [
        { label: 'Salgado', val: 'salgado' },
        { label: 'Doce',    val: 'doce' },
        { label: 'Tanto faz', val: 'qualquer' }
      ] },
    { key: 'objetivo',
      q: 'e o que mais te atrai num biscoito?',
      opts: [
        { label: 'Mais proteína',      val: 'proteina' },
        { label: 'Mais leve / low carb', val: 'leve' },
        { label: 'Os mais queridos',     val: 'vendidos' }
      ] }
  ];
  var quizActive = false;
  function startQuiz(){
    if (!isOpen) openPanel();
    quizActive = true;
    var answers = {}, idx = 0;
    function ask(){
      if (idx >= QUIZ_STEPS.length){ quizActive = false; recommendFromQuiz(answers); return; }
      var step = QUIZ_STEPS[idx];
      addBotBubble(step.q);
      var wrap = document.createElement('div');
      wrap.className = 'szc-quiz';
      step.opts.forEach(function(o){
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'szc-quiz-opt';
        b.textContent = o.label;
        b.setAttribute('aria-label', o.label);
        b.addEventListener('click', function(){
          if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
          addUserBubble(o.label);
          answers[step.key] = o.val;
          idx++;
          showTyping();
          setTimeout(function(){ hideTyping(); ask(); }, 440);
        });
        wrap.appendChild(b);
      });
      bodyEl.appendChild(wrap);
      scrollDown();
    }
    ask();
  }

  function recommendFromQuiz(answers){
    var tipo = answers.tipo || 'qualquer';
    var objetivo = answers.objetivo || 'vendidos';
    var collection = tipo === 'doce' ? 'biscoitos-doces'
                   : tipo === 'salgado' ? 'biscoitos-salgados'
                   : 'all';
    var collUrl = 'https://lojaseedz.com/collections/' + collection;
    showTyping();
    fetchCollectionProducts(collection).then(function(prods){
      hideTyping();
      var picks = pickProducts(prods, objetivo);
      if (!picks.length){
        addBotBubble('tem muita coisa boa esperando por você\n\n[ver os produtos](' + collUrl + ')');
        return;
      }
      /* warm the thumbs early so they're (often) cached by the time the cards paint */
      picks.forEach(function(pp){ try { var pi = new Image(); pi.src = thumbUrl(pp); } catch(e){} });
      addBotBubble('separei essas opções que combinam com você');
      renderProductCards(picks);
      addBotBubble('quer que eu te ajude com mais alguma coisa?');
    }).catch(function(){
      hideTyping();
      addBotBubble('tive um probleminha para carregar as sugestões 😅 dá uma olhada aqui:\n\n[ver os produtos](' + collUrl + ')');
    });
  }

  /* ===== Product data (Shopify storefront JSON) + cards ===== */
  function fetchCollectionProducts(handle){
    var url = '/collections/' + encodeURIComponent(handle) + '/products.json?limit=20';
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function(r){ if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function(j){ return (j && j.products) || []; });
  }
  /* fixpack-v22 (URGENTE): a Mel NUNCA recomenda produto B2B/atacado. Os 10 produtos
     de atacado tem handle com prefixo "caixa-8un-" e tags b2b/atacado. Filtro aplicado
     em TODA superficie que mostra produto (quiz, cards, links, marcadores do backend). */
  function szIsB2B(p){
    var h = (typeof p === 'string') ? p : (p ? (p.handle || p.slug || '') : '');
    h = String(h).toLowerCase();
    if (h.indexOf('caixa-8un') === 0) return true;
    if ((window.__szOcultos || []).indexOf(h) !== -1) return true; /* etapa 47: produto fora da loja (segue ativo por causa das assinaturas), lista em seedz-oculto */
    if (p && typeof p === 'object' && Array.isArray(p.tags)){
      for (var i = 0; i < p.tags.length; i++){
        var t = String(p.tags[i]).toLowerCase();
        if (t === 'b2b' || t === 'atacado' || t === 'caixa-8un') return true;
      }
    }
    return false;
  }
  /* caixa-sabores (04/ago/26): produto MONTAVEL nao pode ter botao de 1 clique no chat.
     A caixa (BUN-*) so faz sentido depois que o cliente escolhe os sabores, que viajam como
     line item property. Um "Adicionar" direto posta a 1a variante SEM property nenhuma, e o
     pedido nasce com uma caixa que a expedicao nao sabe embalar (foi o pedido #6431).
     Existia um isBundle(), mas preso dentro do pickProducts(), e o renderProductCards() nao
     passa por la: a trinca dos "mais pedidos" (SZ_TOP_HANDLES) leva caixa-salgados e chegava
     ao card com botao de adicionar. Aqui a checagem sobe pro escopo do modulo.
     Alem da tag, checamos multiplas variantes, que e o sinal ESTRUTURAL de que ha uma escolha
     a fazer, entao produto montavel novo ja nasce protegido sem mexer neste arquivo. */
  function szIsMontavel(p){
    if (!p) return false;
    try {
      if (Array.isArray(p.variants) && p.variants.length > 1) return true;
      if (Array.isArray(p.tags)){
        for (var i = 0; i < p.tags.length; i++){
          var t = String(p.tags[i]).toLowerCase();
          if (t === 'bundle' || t === 'seedz-native-bundle') return true;
        }
      }
      var h = String(p.handle || '').toLowerCase();
      if (h === 'caixa-salgados' || h === 'caixa-doces') return true;
    } catch(e){}
    return false;
  }
  function pickProducts(prods, objetivo){
    if (!Array.isArray(prods)) return [];
    var TAGMAP = {
      proteina: ['proteico', 'com-proteina', 'proteina'],
      leve:     ['low-carb', 'baixa-caloria'],
      vendidos: ['mais-vendido', 'vendidos-semana']
    };
    var prefer = TAGMAP[objetivo] || [];
    function tagsOf(p){ return (Array.isArray(p.tags) ? p.tags : []).map(function(t){ return normalizeText(t); }); }
    function isBundle(p){ var t = tagsOf(p); return t.indexOf('bundle') !== -1 || t.indexOf('seedz-native-bundle') !== -1; }
    function avail(p){ var v = (p.variants && p.variants[0]) || {}; return v.available !== false; }
    function score(p){
      var t = tagsOf(p), s = 0;
      for (var i = 0; i < prefer.length; i++){ for (var j = 0; j < t.length; j++){ if (t[j].indexOf(prefer[i]) !== -1) s += 10; } }
      if (t.indexOf('mais-vendido') !== -1) s += 2;
      return s;
    }
    var singles = prods.filter(function(p){ return avail(p) && !isBundle(p) && !szIsB2B(p); });
    var pool = singles.length ? singles : prods.filter(function(p){ return avail(p) && !szIsB2B(p); });
    pool.sort(function(a, b){ return score(b) - score(a); });
    return pool.slice(0, 3);
  }
  function formatBRL(priceStr){
    var n = parseFloat(priceStr);
    if (isNaN(n)) return '';
    try { return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
    catch(e){ return 'R$ ' + n.toFixed(2).replace('.', ','); }
  }
  function thumbUrl(p){
    var img = (p.images && p.images[0]);
    var src = img ? (typeof img === 'string' ? img : img.src) : (p.featured_image || '');
    if (!src) return '';
    src = String(src);
    return src + (src.indexOf('?') !== -1 ? '&' : '?') + 'width=132';
  }
  /* Load a product thumb with a RETRY chain. A single transient mobile/CDN miss
     used to set display:none permanently ("a imagem nem aparece"); now it retries
     (cache-busted, backoff) up to 3x and keeps the shimmer meanwhile. eager because
     native lazy-load does NOT fire inside the fixed/scrollable chat panel. */
  function attachProdImg(img, url){
    img.decoding = 'async';
    /* Fetch as a webp blob (Accept EXCLUDES avif) so the thumb shows in a format
       EVERY device decodes, bypassing the <img> AVIF content-negotiation that was
       failing on some phones ("nenhuma imagem aparece"). Falls back to a direct
       <img> with retry if the cross-origin fetch is blocked. */
    fetch(url, { headers: { 'Accept': 'image/webp,image/png,image/jpeg,image/*' } })
      .then(function(r){ if (!r.ok) throw 0; return r.blob(); })
      .then(function(b){ img.onload = function(){ img.classList.add('szc-loaded'); }; img.src = URL.createObjectURL(b); })
      .catch(function(){
        var tries = 0;
        img.loading = 'eager'; img.setAttribute('fetchpriority', 'high');
        img.addEventListener('load', function(){ img.classList.add('szc-loaded'); });
        img.addEventListener('error', function(){
          if (tries < 2){ tries++; setTimeout(function(){ img.src = url + (url.indexOf('?') !== -1 ? '&' : '?') + '_r=' + tries; }, 400 * tries); }
          else { img.classList.add('szc-loaded'); img.style.display = 'none'; }
        });
        img.src = url;
      });
  }
  function renderProductCards(prods){
    /* fixpack-v22 (URGENTE): chokepoint final, nunca renderiza card de produto B2B/atacado */
    prods = (prods || []).filter(function(p){ return p && !szIsB2B(p); });
    if (!prods.length) return;
    var wrap = document.createElement('div');
    wrap.className = 'szc-prods';
    prods.forEach(function(p){
      var v = (p.variants && p.variants[0]) || {};
      var card = document.createElement('div'); card.className = 'szc-prod';
      var img = document.createElement('img'); img.className = 'szc-prod-img';
      img.alt = ''; img.setAttribute('aria-hidden', 'true');
      attachProdImg(img, thumbUrl(p));
      var main = document.createElement('div'); main.className = 'szc-prod-main';
      var nm = document.createElement('div'); nm.className = 'szc-prod-name'; nm.textContent = p.title || '';
      var pr = document.createElement('div'); pr.className = 'szc-prod-price'; pr.textContent = formatBRL(v.price);
      var acts = document.createElement('div'); acts.className = 'szc-prod-acts';
      var view = document.createElement('a'); view.className = 'szc-prod-view';
      view.href = '/products/' + p.handle;
      view.textContent = 'Ver produto';
      var add;
      if (szIsMontavel(p)){
        /* caixa-sabores: montavel vai pra PDP montar, nunca entra no carrinho daqui */
        add = document.createElement('a'); add.className = 'szc-prod-add';
        add.href = '/products/' + p.handle;
        add.textContent = 'Montar caixa';
      } else {
        add = document.createElement('button'); add.type = 'button'; add.className = 'szc-prod-add';
        add.textContent = 'Adicionar';
        if (v.id && v.available !== false){
          add.addEventListener('click', function(){ addProductToCart(v.id, add); });
        } else { add.disabled = true; add.textContent = 'Indisponível'; }
      }
      acts.appendChild(view); acts.appendChild(add);
      main.appendChild(nm); main.appendChild(pr); main.appendChild(acts);
      card.appendChild(img); card.appendChild(main);
      wrap.appendChild(card);
    });
    bodyEl.appendChild(wrap);
    scrollDown();
  }
  function addProductToCart(vid, btn){
    if (btn){ btn.disabled = true; btn.textContent = 'Adicionando...'; }
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    })
    .then(function(r){ if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
    .then(function(){
      if (btn){ btn.disabled = true; btn.textContent = '✓ Adicionado'; }
      addBotBubble('adicionei ao seu carrinho');
      addCartCta();
      try { document.dispatchEvent(new CustomEvent('theme:cart:change')); } catch(e){}
    })
    .catch(function(){
      if (btn){ btn.disabled = false; btn.textContent = 'Adicionar'; }
      addBotBubble('ops, não consegui adicionar agora 😅 abre o produto que dá para adicionar por lá.');
    });
  }
  /* "ver meu carrinho": a button OUTSIDE the message bubble that CLOSES the chat
     and opens the cart DRAWER (the store flow has no /cart page). Mechanism copied
     from the theme's own add-to-cart success path (seedz-global-fixes). */
  function openCartDrawer(){
    closePanel();
    try { document.dispatchEvent(new CustomEvent('theme:cart:change')); } catch(e){}
    setTimeout(function(){
      var ci = document.querySelector('a[aria-controls="CartDrawer"], .js-drawer-open-cart, [data-drawer-open="cart"]');
      if (ci){ try { ci.click(); } catch(e){} }
    }, 160);
  }
  function addCartCta(){
    if (bodyEl.querySelector('.szc-cart-cta')) return; /* only one */
    var wrap = document.createElement('div'); wrap.className = 'szc-cartwrap';
    var b = document.createElement('button'); b.type = 'button'; b.className = 'szc-cart-cta';
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg><span>ver meu carrinho</span>';
    b.addEventListener('click', openCartDrawer);
    wrap.appendChild(b); bodyEl.appendChild(wrap); scrollDown();
  }

  /* ===== Tappable option chips from a [[OPCOES]] reply ===== */
  function addOptionChips(options){
    try {
      var wrap = document.createElement('div');
      wrap.className = 'szc-quiz';
      options.forEach(function(opt){
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'szc-quiz-opt';
        b.textContent = opt;
        b.setAttribute('aria-label', opt);
        b.addEventListener('click', function(){
          if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
          sendMessage(opt);
        });
        wrap.appendChild(b);
      });
      bodyEl.appendChild(wrap);
      scrollDown();
    } catch(e){ /* chips are non-critical */ }
  }

  /* ===== API: chat turn ===== */

  /* ====== CÉREBRO DE RESPOSTAS PRONTAS (canned, client-side) — Phase W1 ====== */
  /* Reviews agregados: o snippet Liquid calcula e injeta em window.szChatCfg.reviews
     ANTES deste arquivo carregar. Fallback = mesmos defaults do Liquid original. */
  var SZ_REVIEWS = (window.szChatCfg && window.szChatCfg.reviews) || {count: 0, rating: '4.8'};
  var SZ_NUTRI = {
    proteico:{n:'Biscoito Proteico Parmesão',kcal:213,prot:'13g',carb:'17g',fib:'5,3g',sod:'237mg',ff:'sem glúten, sem lactose'},
    curcuma:{n:'Cracker de Cúrcuma',kcal:121,prot:'2,6g',carb:'13g',fib:'1,8g',sod:'133mg',ff:'low carb, sem glúten, sem lactose, vegano'},
    alecrim:{n:'Cracker de Alecrim',kcal:117,prot:'2,4g',carb:'13g',fib:'1,4g',sod:'139mg',ff:'sem glúten, sem lactose, vegano'},
    gergelim:{n:'Cracker de Gergelim',kcal:126,prot:'2,8g',carb:'12g',fib:'1,6g',sod:'144mg',ff:'sem glúten, sem lactose, vegano'},
    pizza:{n:'Cracker de Pizza',kcal:119,prot:'2,4g',carb:'13g',fib:'1,5g',sod:'138mg',ff:'sem glúten, sem lactose, vegano'},
    grissini:{n:'Grissini',kcal:116,prot:'2,5g',carb:'12g',fib:'1,4g',sod:'182mg',ff:'sem glúten, sem lactose, vegano'},
    parmesao:{n:'Grissini Parmesão',kcal:133,prot:'2,6g',carb:'14g',fib:'1,5g',sod:'202mg',ff:'sabor parmesão, sem glúten, sem lactose, vegano'},
    castanhas:{n:'Mini Cookie de Castanhas',kcal:199,prot:'3,1g',carb:'21g',fib:'5,4g',sod:'21mg',ff:'sem açúcar adicionado, sem glúten, sem lactose, vegano'},
    chocolate:{n:'Mini Cookie de Chocolate 70%',kcal:201,prot:'3,1g',carb:'22g',fib:'6g',sod:'21mg',ff:'sem açúcar adicionado, sem glúten, sem lactose, vegano'}
  };
  var SZ_ALIAS = [['proteico',['proteico','proteina parmesao','biscoito proteico']],['parmesao',['grissini parmesao','grissini parmesão']],['curcuma',['curcuma','cúrcuma']],['alecrim',['alecrim']],['gergelim',['gergelim']],['pizza',['pizza']],['grissini',['grissini']],['castanhas',['castanha','castanhas']],['chocolate',['chocolate','cacau','cookie de chocolate']]];
  var SZ_CANNED = [
   {t:['quanto custa o frete','valor do frete','preco do frete','preco da entrega'],a:'O frete é calculado pelo seu CEP lá no checkout, é só colocar os produtos no carrinho e informar o CEP que o valor e o prazo aparecem certinho. E dá para ganhar frete grátis: no Sudeste a partir de R$179, nas demais regiões a partir de R$219, e na assinatura a partir de R$139 em qualquer região.'},
   {t:['tem frete gratis','frete gratis','a partir de quanto frete','frete free'],a:'Temos frete grátis sim! No Sudeste (SP, RJ, MG e ES) a partir de R$179, e nas demais regiões a partir de R$219. E quem é assinante ganha frete grátis a partir de R$139, em qualquer região.'},
   {t:['quanto tempo demora','prazo de entrega','quando chega','demora pra chegar','quanto tempo pra chegar'],a:'O seu pedido é enviado em média de 2 a 3 dias úteis após a confirmação do pagamento. O prazo que aparece no checkout pelo seu CEP começa a contar a partir desse envio, quando entregamos o pedido à transportadora. Assim que o pedido sai, você recebe o código de rastreio para acompanhar.'},
   {t:['como funciona a assinatura','o que e a assinatura','assinatura seedz'],a:'Na assinatura seedz você escolhe os produtos e os sabores e recebe na frequência que preferir, a cada 7, 15 ou 30 dias. Vale para qualquer produto, não só as caixas. Você ganha 10% de desconto em toda entrega e frete grátis a partir de R$139.'},
   {t:['desconto da assinatura','assinante paga menos','assinatura tem desconto'],a:'Quem é assinante ganha 10% de desconto em toda entrega e frete grátis a partir de R$139, em qualquer região. É a forma mais econômica de manter os seus biscoitos sempre em casa.'},
   {t:['cancelar a assinatura','como pausar','pausar assinatura','cancelar quando quiser','cancelo a assinatura'],a:'Dá para pausar, trocar os sabores ou cancelar a sua assinatura pelo próprio site, a partir da 2ª entrega, sem complicação. É só entrar na sua conta, na área de assinatura, e gerenciar tudo do seu jeito.'},
   {t:['tem gluten','sem gluten','pode pra celiaco','contem gluten','glutem'],a:'São todos sem glúten, sim! Todos os produtos seedz são seguros para quem é celíaco ou tem sensibilidade. Quer que eu te indique alguns para começar?',o:['Quero ver opções','Tudo certo, obrigada'],ofr:'top'},
   {t:['tem lactose','sem lactose','tem leite','intolerante a lactose','aplv','alctrose','lactse','latose','lactoze'],a:'Não tem lactose, não. Tudo na seedz é zero lactose e sem leite, feito para quem tem intolerância ou APLV. Se quiser, eu te mostro as opções mais queridas.',o:['Quero ver as opções','Tudo certo, obrigada'],ofr:'top'},
   {t:['e vegano','sao veganos','tem origem animal','ingrediente animal'],a:'São sim! Tudo na seedz é 100% vegano, sem nenhum ingrediente de origem animal. Quer que eu te mostre os mais pedidos?',o:['Me mostra os mais pedidos','Tudo certo, obrigada'],ofr:'top'},
   {t:['tem acucar','sem acucar','tem adocante','acucar adicionado'],a:'Nenhum produto tem açúcar adicionado. Os doces são adoçados de forma natural, sem adição de açúcares. Quer que eu te indique um docinho sem culpa?',o:['Quero um docinho','Tudo certo, obrigada'],ofr:'doces'},
   {t:['pode pra quem tem diabetes','diabetico pode comer','sou diabetico','diabetes'],a:'Todos os produtos são sem açúcar adicionado e feitos com ingredientes que você conhece, sem farinha branca nem refinados, então muita gente que controla o açúcar curte. Para um caso específico, vale confirmar com o seu nutricionista. Quer que eu te mostre os com menos carboidrato?',o:['Mostrar menos carbo','Tudo certo, obrigada'],ofr:'menos-carbo'},
   {t:['tem proteina','rico em proteina','algo proteico','muita proteina','mais proteina'],a:'Temos opções bem proteicas! O Biscoito Proteico Parmesão tem 13g de proteína por pacote, e as proteínas auxiliam na formação de músculos e ossos. Quer que eu te mostre?',o:['Quero ver','Tudo certo, obrigada'],ofr:'proteico'},
   {t:['quais as formas de pagamento','formas de pagamento','como pagar','como pago','meios de pagamento'],a:'Você pode pagar no Pix, que ainda dá 5% de desconto e cai na hora, ou no cartão de crédito à vista. A gente não trabalha com parcelamento. Para a assinatura, o pagamento é no cartão de crédito.'},
   {t:['paga no pix','pode pix','desconto no pix'],a:'Pode pagar no Pix sim, com 5% de desconto e aprovação na hora. É só escolher Pix no checkout.'},
   {t:['cartao de credito','aceita cartao','parcela','quantas vezes','parcelamento'],a:'Aceitamos cartão de crédito à vista, sem parcelamento. Para a assinatura, o pagamento também é no cartão de crédito.'},
   {t:['qual a validade','validade dos produtos','vence quando','prazo de validade'],a:'Cada produto vem com a validade impressa na embalagem, certinho. Me diz qual item que eu confirmo para você por aqui.'},
   {t:['como guardar','como armazenar','como conservar','onde guardar'],a:'É só guardar em local fresco e seco e fechar bem a embalagem depois de aberta, para manter aquela crocância de sempre.'},
   {t:['vale a pena','e bom mesmo','vale a pena comprar'],a:'Vale a pena, sim. São mais de __RVCOUNT__ avaliações com nota __RVRATING__, e as clientes gostam justamente por ser gostoso de verdade sem sair da dieta. Quer que eu te indique um para experimentar?',o:['Me indica um','Tudo certo, obrigada'],ofr:'top'},
   {t:['e confiavel','loja confiavel','e seguro comprar','site confiavel','o que falam','o que as pessoas falam','tem avaliacao','tem avaliacoes','tem review','as avaliacoes','quantas avaliacoes','avaliacao','avaliacoes','review','reviews','nota da loja','estrelas','quantas estrelas'],a:'Somos uma marca brasileira com mais de __RVCOUNT__ avaliações (nota __RVRATING__), com pagamento seguro e troca garantida. Você pode ler os comentários na página de cada produto, lá embaixo. Qualquer dúvida, a gente te ajuda por aqui ou no WhatsApp.'},
   {t:['onde comprar','loja fisica','onde encontro','tem em loja','tem loja fisica','onde vende','vende em supermercado'],a:'A seedz está em várias lojas pelo Brasil! É só dar uma olhadinha aqui para achar a mais pertinho de você:\n\n[Onde encontrar](/pages/onde-encontrar)'},
   {t:['como trocar','troca e devolucao','como faco pra trocar','quero trocar'],a:'Trocas e devoluções o time da seedz resolve certinho com você. Quer que eu te encaminhe para uma pessoa do nosso time agora?',h:true},
   {t:['chegou quebrado','veio quebrado','veio danificado','produto avariado','chegou amassado'],a:'Poxa, sinto muito que chegou assim, não é o que a gente quer para você de jeito nenhum. A gente resolve rapidinho: me chama no WhatsApp com uma foto do produto e o número do seu pedido que cuidamos disso.',h:true},
   {t:['quero devolver','meu dinheiro de volta','me arrependi','arrependimento','devolver o produto'],a:'Você tem até 7 dias depois de receber para desistir da compra e devolver (é o direito de arrependimento), e nesse caso a gente devolve o valor pago. Me chama no WhatsApp que organizo isso com você.',h:true}
  ];
  var SZ_PROD={proteico:{h:'biscoito-proteico',v:'42597169725536'},curcuma:{h:'curcuma-linhaca',v:'41179060502624'},alecrim:{h:'cracker-de-alecrim',v:'41179061059680'},gergelim:{h:'cracker-de-gergelim',v:'41179059159136'},pizza:{h:'cracker-de-pizza',v:'41179058569312'},grissini:{h:'grissini',v:'41179047821408'},parmesao:{h:'grissini-parmesao',v:'41829092655200'},castanhas:{h:'mini-cookie-castanhas',v:'41179046707296'},chocolate:{h:'mini-cookie-de-chocolate',v:'41179045920864'}};
  function szProductButtons(key){
    var p=SZ_PROD[key]; if(!p||!bodyEl) return;
    if(bodyEl.querySelector('.szc-prodb[data-k="'+key+'"]')) return;
    var wrap=document.createElement('div'); wrap.className='szc-prodb'; wrap.setAttribute('data-k',key);
    wrap.style.cssText='display:flex;flex-wrap:wrap;gap:8px;margin:2px 0 6px;';
    var see=document.createElement('a'); see.href='/products/'+p.h; see.target='_blank'; see.rel='noopener';
    see.className='szc-quiz-opt'; see.textContent='Ver produto';
    var add=document.createElement('button'); add.type='button'; add.className='szc-quiz-opt'; add.textContent='Adicionar ao carrinho';
    add.style.cssText='background:var(--szc-marrom,#603813);color:#fff;border-color:var(--szc-marrom,#603813);';
    add.addEventListener('click',function(){ try{ addProductToCart(p.v, add); }catch(e){} });
    wrap.appendChild(see); wrap.appendChild(add); bodyEl.appendChild(wrap);
    if(typeof scrollDown==='function') scrollDown();
  }
  function szNutriAnswer(nt){
    var keyM=/caloria|kcal|proteina|carboidrato|fibra|sodio|tabela|nutricional|macro|quantas calorias|valor energetico/;
    if(!keyM.test(nt)) return null;
    for(var i=0;i<SZ_ALIAS.length;i++){ var k=SZ_ALIAS[i][0], al=SZ_ALIAS[i][1];
      for(var j=0;j<al.length;j++){ if(nt.indexOf(normalizeText(al[j]))!==-1){ var d=SZ_NUTRI[k];
        return {a:'Na porção de 40g do '+d.n+': '+d.kcal+' kcal, '+d.prot+' de proteína, '+d.carb+' de carboidrato, '+d.fib+' de fibras e '+d.sod+' de sódio. '+d.ff.charAt(0).toUpperCase()+d.ff.slice(1)+'.', prod:k}; } } }
    return {a:'Me diz qual produto que eu passo a tabela completa: porção, calorias, carboidratos, proteínas, fibras e sódio, tudo certinho.'};
  }
  function szProductInfo(nt){
    if(!/me fala|fala do|fala da|quero o |quero a |tem o |tem a |sobre o |sobre a |me mostra|recomenda|conta sobre|me conta|qual o /.test(nt)) return null;
    for(var i=0;i<SZ_ALIAS.length;i++){ var k=SZ_ALIAS[i][0], al=SZ_ALIAS[i][1];
      for(var j=0;j<al.length;j++){ if(nt.indexOf(normalizeText(al[j]))!==-1){ var d=SZ_NUTRI[k];
        return {a:'O '+d.n+' é '+d.ff+'. Na porção de 40g tem '+d.kcal+' kcal e '+d.prot+' de proteína. Quer ver ou já adicionar?', prod:k}; } } }
    return null;
  }
  function szCannedMatch(text){
    var nt=normalizeText(text);
    var na=szNutriAnswer(nt); if(na) return na;
    var pi=szProductInfo(nt); if(pi) return pi;
    var best=null,bestLen=0;
    for(var i=0;i<SZ_CANNED.length;i++){ var e=SZ_CANNED[i];
      for(var j=0;j<e.t.length;j++){ var trg=e.t[j]; if(nt.indexOf(trg)!==-1 && trg.length>bestLen){ best=e; bestLen=trg.length; } } }
    return best;
  }
  function szReviewVars(s){
    try{ var n=(SZ_REVIEWS&&SZ_REVIEWS.count)||0; var rvc = n>0 ? Math.max(100, Math.floor(n/100)*100) : 1000; var rr=(SZ_REVIEWS&&SZ_REVIEWS.rating)||'4.8';
      return s.replace(/__RVCOUNT__/g, rvc).replace(/__RVRATING__/g, rr);
    }catch(e){ return s.replace(/__RVCOUNT__/g,'1000').replace(/__RVRATING__/g,'4.8'); }
  }
  function szTryCanned(text){
    var e=szCannedMatch(text); if(!e) return false;
    /* Registro total: qual entrada casou. O primeiro gatilho serve de chave
       estavel; as respostas de nutricao/produto nao tem gatilho, e usam o
       produto. */
    try{ szTurnKey = (e.t && e.t[0]) ? e.t[0] : (e.prod ? ('produto:' + e.prod) : null); }catch(er){}
    /* P2b: arma (ou limpa) a oferta pendente pro follow-up curto ("quero", "sim") */
    window.__szLastOffer = e.ofr || null;
    streamBotBubbles(szReviewVars(e.a), function(){ if(e.h){ addHandoffButton('canned'); } if(e.o){ addOptionChips(e.o); } if(e.prod){ szProductButtons(e.prod); } });
    return true;
  }

  /* ====== MEL BACKEND (IA): fallback off-script + continuidade de follow-up ====== */

  /* P2d: textos exatos dos chips de oferta -> chave da ação */
  var SZ_CHIP_OFFERS = {
    'quero ver opcoes': 'top',
    'quero ver as opcoes': 'top',
    'me mostra os mais pedidos': 'top',
    'quero um docinho': 'doces',
    'mostrar menos carbo': 'menos-carbo',
    'quero ver': 'proteico',
    'me indica um': 'top'
  };

  /* P2c: afirmacao curta ("quero", "sim", "pode ser"), no maximo 4 palavras */
  function isShortAffirmation(text){
    var n = normalizeText(text);
    if (!n) return false;
    if (n.split(' ').length > 4) return false;
    return /^(quero|sim|pode|pode ser|claro|ok|okay|isso|aham|uhum|manda|mostra|me mostra|bora|vamos|quero sim|quero ver|por favor|adoraria)\b/.test(n);
  }

  /* P3.1: trinca default dos mais pedidos. "caixa-salgados" nao esta no SZ_PROD,
     hardcode de proposito: trinca default, Diogo pode trocar os handles aqui. */
  /* etapa94 (dg 29/out/26): Biscoito de Coco, Kit Doce e DOCE10 sairam da loja; entra o 3o avulso mais vendido */
  var SZ_TOP_HANDLES = ['caixa-mista', 'biscoito-proteico', 'cracker-de-gergelim'];
  function szShowTopProducts(){
    addBotBubble('esses são os queridinhos por aqui 🙂');
    renderMelProductCards(SZ_TOP_HANDLES);
  }

  /* P2d: executa a oferta pendente (top | doces | menos-carbo | proteico) */
  function szRunOffer(key){
    try{
      if (key === 'doces'){
        addBotBubble('olha esses docinhos, todos sem açúcar adicionado 🙂');
        renderMelProductCards(['mini-cookie-castanhas', 'mini-cookie-de-chocolate']);
        return;
      }
      if (key === 'menos-carbo'){
        addBotBubble('esses são os mais levinhos em carboidrato 🙂');
        renderMelProductCards(['curcuma-linhaca', 'cracker-de-alecrim', 'cracker-de-gergelim']);
        return;
      }
      if (key === 'proteico'){
        addBotBubble('esse é o nosso campeão de proteína, com 13g por pacote 💪');
        szProductButtons('proteico');
        return;
      }
      szShowTopProducts();
    }catch(e){}
  }

  /* [[PRODUTOS:h1|h2]] / ofertas locais -> cards via /products/<handle>.js.
     ATENCAO: esse endpoint devolve price em CENTAVOS (int); formatBRL espera
     reais (string "15.00", como o products.json da collection) -> divide por 100. */
  function renderMelProductCards(handles, onDone){
    handles = (handles || []).filter(function(h){ return !szIsB2B(h); }); /* fixpack-v22: sem B2B */
    var jobs = handles.slice(0, 6).map(function(h){
      return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r){ if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function(p){
          if (!p || !p.title) return null;
          var variants = (Array.isArray(p.variants) ? p.variants : []).map(function(v){
            var cents = parseFloat(v.price);
            return { id: v.id, available: v.available !== false, price: isNaN(cents) ? '' : (cents / 100).toFixed(2) };
          });
          return { title: p.title, handle: p.handle || h, variants: variants,
                   images: Array.isArray(p.images) ? p.images : [], featured_image: p.featured_image || '' };
        })
        .catch(function(){ return null; });
    });
    Promise.all(jobs).then(function(list){
      var prods = [];
      for (var i = 0; i < list.length; i++){ if (list[i]) prods.push(list[i]); }
      if (prods.length) renderProductCards(prods);
      if (onDone) onDone(prods.length);
    }).catch(function(){ if (onDone) onDone(0); });
  }

  /* [[PRODUTO:slug:Nome]] -> botao "Acessar <Nome>" (estilo dos botoes existentes) */
  function addMelProductLink(p){
    if (szIsB2B(p)) return; /* fixpack-v22 (URGENTE): nunca link pra produto B2B/atacado */
    try{
      var wrap = document.createElement('div');
      wrap.className = 'szc-prodb';
      wrap.style.cssText = 'display:flex;flex-wrap:wrap;gap:8px;margin:2px 0 6px;';
      var a = document.createElement('a');
      a.href = '/products/' + encodeURIComponent(p.slug);
      a.target = '_blank'; a.rel = 'noopener';
      a.className = 'szc-quiz-opt';
      a.textContent = 'Acessar ' + p.name;
      wrap.appendChild(a);
      bodyEl.appendChild(wrap);
      scrollDown();
    }catch(e){}
  }

  /* P0.2: parser da resposta do Mel backend (markers do contrato caps v2) */
  function renderMelResponse(raw){
    try{
      var text = String(raw == null ? '' : raw).replace(/\r\n/g, '\n');

      /* 1. [[HANDOFF]] -> flag (o botao entra por ultimo) */
      var wantsHandoff = text.indexOf(HANDOFF_MARKER) !== -1;
      if (wantsHandoff) text = text.split(HANDOFF_MARKER).join('\n');

      /* 2. [[OPCOES: a | b | c]] -> chips tocaveis */
      var chipOpts = null;
      text = text.replace(/\[\[OPCOES:([^\]]*)\]\]/gi, function(m, body){
        var opts = [];
        body.split('|').forEach(function(s){ s = s.trim(); if (s) opts.push(s); });
        if (opts.length) chipOpts = opts;
        return '\n';
      });

      /* 3. [[PRODUTO:slug:Nome]] -> botao "Acessar <Nome>" */
      var prodLinks = [];
      text = text.replace(/\[\[PRODUTO:([^:\]]+):([^\]]+)\]\]/gi, function(m, slug, name){
        slug = slug.trim(); name = name.trim();
        if (slug && name) prodLinks.push({ slug: slug, name: name });
        return '\n';
      });

      /* 4. [[PRODUTOS:h1|h2|h3]] -> cards de produto */
      var prodHandles = [];
      text = text.replace(/\[\[PRODUTOS:([^\]]*)\]\]/gi, function(m, body){
        body.split('|').forEach(function(h){ h = h.trim(); if (h) prodHandles.push(h); });
        return '\n';
      });

      /* 5. [[SPLIT]] -> quebra de bolha (vira paragrafo; streamBotBubbles separa) */
      text = text.replace(/\s*\[\[SPLIT\]\]\s*/gi, '\n\n');

      /* 7. DEFESA: strip de qualquer [[...]] residual, nunca mostrar marker cru */
      text = text.replace(/\[\[[^\]]*\]\]/g, ' ').trim();

      var finish = function(){
        for (var i = 0; i < prodLinks.length; i++) addMelProductLink(prodLinks[i]);
        var after = function(){
          if (chipOpts) addOptionChips(chipOpts);
          if (wantsHandoff) addHandoffButton('handoff'); /* 6 */
        };
        if (prodHandles.length) renderMelProductCards(prodHandles, after);
        else after();
      };

      if (text){
        streamBotBubbles(text, function(lastEl){
          maybeAppendRegionFrete(text, lastEl);
          finish();
        });
      } else {
        hideTyping();
        if (!wantsHandoff && !chipOpts && !prodLinks.length && !prodHandles.length){
          addBotBubble(ERROR_MSG);
          addHandoffButton('handoff');
          return;
        }
        finish();
      }
    }catch(e){
      hideTyping();
      addBotBubble(ERROR_MSG);
      addHandoffButton('handoff');
    }
  }

  /* P0.1: POST /api/shopify/chat (caps v2), o cerebro IA do backend */
  function callMelBackend(text){
    if (inFlight) return;
    setInFlight(true);
    showTyping();
    var payload = { message: text };
    var cid = getCid();
    if (cid) payload.conversationId = cid;
    fetch(API_BASE + '/api/shopify/chat', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Ultron-Account-Key': KEY,
        'X-Sz-Widget-Caps': 'v2'
      },
      body: JSON.stringify(payload)
    })
    .then(function(res){
      if (!res.ok){ var e = new Error('HTTP ' + res.status); e.szStatus = res.status; throw e; }
      return res.json();
    })
    .then(function(d){
      if (!d || typeof d.response !== 'string' || !d.response.trim()){ throw new Error('empty response'); }
      setCid(d.conversationId);
      setInFlight(false);
      renderMelResponse(d.response);
      /* Registro total: o rotulo so da para saber DEPOIS da resposta, por
         isso e aqui e nao no roteador. Tira os markers do contrato v2 para
         a previa guardada ser o texto que o visitante leu. */
      szReportTurn(text, 'ultron_ia', null, String(d.response).replace(/\[\[[^\]]*\]\]/g, ' '), d.conversationId);
    })
    .catch(function(err){
      setInFlight(false);
      hideTyping();
      if (err && err.szStatus === 429){ addBotBubble(RATE_LIMIT_MSG); }
      else { addBotBubble(ERROR_MSG); }
      addHandoffButton('handoff');
      /* Registro total: aqui o visitante NAO foi atendido. E a linha que a
         aba lista como nao respondida — hoje esse caso e invisivel. */
      szReportTurn(text, 'sem_resposta', (err && err.szStatus === 429) ? 'rate_limit' : 'erro', null);
    });
  }

  /* Registro total: o roteador de camadas virou szRouteMessage, e sendMessage
     passou a ser o envelope que reporta UM turno por mensagem. Assim o
     reporte fica num lugar so, em vez de espalhado pelos ~11 pontos de saida
     do roteador, e nenhum caminho pode esquecer de reportar. */
  function sendMessage(text){
    szTurnLayer = null; szTurnKey = null; szTurnAnswer = ''; szTurnStarted = false;
    var szQ = (text || '').trim();
    try {
      szRouteMessage(text);
    } finally {
      /* 'deferido' = quem responde e o backend, e callMelBackend reporta
         sozinho com o rotulo certo (ultron_ia se respondeu, sem_resposta se
         falhou). Reportar aqui tambem contaria o mesmo turno duas vezes. */
      try{
        if (szTurnStarted && szQ && szTurnLayer !== 'deferido'){
          szReportTurn(szQ, szTurnLayer || 'outro', szTurnKey, szTurnAnswer);
        }
      }catch(e){}
    }
  }

  function szRouteMessage(text){
    if (inFlight) return;
    text = (text || '').trim();
    if (!text) return;

    szTurnStarted = true;
    addUserBubble(text);
    input.value = '';
    autoGrow();

    var szNt = normalizeText(text);

    /* P2a/d: textos exatos dos chips de oferta -> acao mapeada (antes de tudo) */
    if (szNt === 'tudo certo, obrigada' || szNt === 'tudo certo obrigada'){
      szTurnLayer = 'oferta'; szTurnKey = 'dispensa';
      window.__szLastOffer = null;
      addBotBubble('combinado! qualquer coisa é só me chamar por aqui 🙂');
      return;
    }
    if (Object.prototype.hasOwnProperty.call(SZ_CHIP_OFFERS, szNt)){
      var szChipKey = window.__szLastOffer || SZ_CHIP_OFFERS[szNt];
      szTurnLayer = 'oferta'; szTurnKey = szChipKey;
      window.__szLastOffer = null;
      szRunOffer(szChipKey);
      return;
    }

    /* P2c: afirmacao curta -> roda a oferta pendente; sem oferta, manda pro
       backend (o historico do servidor resolve o follow-up) */
    if (isShortAffirmation(text)){
      var szOffer = window.__szLastOffer;
      window.__szLastOffer = null;
      if (szOffer){ szTurnLayer = 'oferta'; szTurnKey = szOffer; szRunOffer(szOffer); }
      else { szTurnLayer = 'deferido'; callMelBackend(text); }
      return;
    }

    /* P1: saudacao -> oi caloroso + quick actions (antes do help) */
    if (hasGreetingIntent(text)){
      szTurnLayer = 'saudacao';
      addBotBubble('oi! que bom te ver por aqui 🙂 me conta, como posso te ajudar hoje?');
      addQuickActions();
      return;
    }

    /* Tracking intent -> open the in-chat order picker instead of asking the bot */
    if (hasTrackingIntent(text)){
      szTurnLayer = 'rastreio';
      addBotBubble('claro! vou te ajudar a achar seu pedido');
      openOrderPicker();
      return;
    }

    /* Recommendation intent -> run the guided quiz instead of a wall-of-text */
    if (hasRecommendIntent(text)){
      szTurnLayer = 'recomendacao';
      startQuiz();
      return;
    }

    /* Help / menu intent -> re-show the tappable quick actions (cards, not running text) */
    if (hasHelpIntent(text)){
      szTurnLayer = 'ajuda';
      addBotBubble('claro com o que posso te ajudar?');
      addQuickActions();
      return;
    }

    /* Frete menu intent (bare "frete") -> tappable options (balões) instead of running text */
    if (hasFreteMenuIntent(text)){
      szTurnLayer = 'menu'; szTurnKey = 'menu-frete';
      addBotBubble('posso te ajudar com o frete, sobre o que você quer saber?');
      addOptionChips(['Frete grátis', 'Valor do frete', 'Rastrear entrega']);
      return;
    }

    /* Frete sub-options (determinístico, client-side) para os balões SEMPRE responderem */
    var szNf = normalizeText(text);
    if (szNf === 'frete gratis' || szNf === 'frete e gratis' || szNf === 'frete free'){
      szTurnLayer = 'frete'; szTurnKey = 'frete-gratis';
      addBotBubble('boa! no Sudeste (SP, RJ, MG e ES) o frete fica grátis a partir de R$179, nas demais regiões a partir de R$219, e quem é assinante ganha grátis a partir de R$139 em qualquer região. o valor exato aparece no checkout pelo seu CEP.');
      return;
    }
    if (szNf === 'valor do frete'){
      szTurnLayer = 'frete'; szTurnKey = 'valor-do-frete';
      addBotBubble('o valor do frete é calculado pelo seu CEP. me manda seu CEP (só os números) que eu te digo o valor e a partir de quanto fica grátis na sua região.');
      return;
    }

    /* CEP intent -> compute the region's free-shipping threshold in-chat (deterministic) */
    var szCepM = text.match(/(\d{5})-?\s?(\d{3})/);
    if (szCepM){
      var szDigitCount = text.replace(/\D/g, '').length;
      var szNlow = normalizeText(text);
      if (szDigitCount === 8 || text.indexOf('-') !== -1 || /frete|cep|entrega|envio|chega|regiao|valor/.test(szNlow)){
        if (answerFreightForCep(szCepM[1] + szCepM[2])){ szTurnLayer = 'frete'; szTurnKey = 'cep'; return; }
      }
    }

    /* === Cerebro de respostas prontas (W1) === */
    if (szTryCanned(text)){ szTurnLayer = 'canned'; return; }

    /* === Off-script: nada casou nas camadas deterministicas -> Mel backend (IA).
       Loga a pergunta (pro aprendizado) e pergunta pro cerebro real. === */
    szLogUnanswered(text);
    szTurnLayer = 'deferido';
    callMelBackend(text);
    return;
  }

  /* ===== Handoff humano (W1d): resumo client-side + WhatsApp, sem Ultron ===== */
  function doHandoff(btn){
    openDirectWhatsApp();
  }

  /* ===== UI helpers ===== */
  function setInFlight(v){
    inFlight = v;
    sendBtn.disabled = v;
    input.setAttribute('aria-busy', v ? 'true' : 'false');
  }

  function autoGrow(){
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 110) + 'px';
  }

  /* ===== Scroll-lock: freeze the main page while the chat is open (iOS-safe) ===== */
  var _szScrollY = 0;
  function lockScroll(){
    try{
      _szScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.style.top = '-' + _szScrollY + 'px';
      document.documentElement.classList.add('szc-locked');
      document.body.classList.add('szc-noscroll');
    }catch(e){}
  }
  function unlockScroll(){
    try{
      document.documentElement.classList.remove('szc-locked');
      document.body.classList.remove('szc-noscroll');
      document.body.style.top = '';
      window.scrollTo(0, _szScrollY);
    }catch(e){}
  }

  /* ===== Guard: keep the input field from being tinted by browser / password-manager
     autofill (the "box roxo"). Re-asserts a transparent background no matter what
     gets injected (CSS alone loses to inline !important from an extension). ===== */
  function killInputTint(){
    try{
      if (input.style.backgroundColor !== 'transparent') input.style.setProperty('background-color', 'transparent', 'important');
      if (input.style.backgroundImage !== 'none') input.style.setProperty('background-image', 'none', 'important');
    }catch(e){}
  }

  function openPanel(){
    if (isOpen) return;
    isOpen = true;
    lockScroll();
    lastFocus = document.activeElement;
    panel.hidden = false;
    backdrop.hidden = false;
    root.classList.add('szc-open');
    toggleBtn.setAttribute('aria-expanded', 'true');
    if (!greeted){ greeted = true; streamBotBubbles(GREETING, function(){ addQuickActions(); }); }
    setTimeout(function(){ try { input.focus({ preventScroll: true }); } catch(e){ input.focus(); } }, 120);
    scrollDown();
  }
  function closePanel(){
    if (!isOpen) return;
    isOpen = false;
    unlockScroll();
    root.classList.remove('szc-open');
    toggleBtn.setAttribute('aria-expanded', 'false');
    setTimeout(function(){ if (!isOpen){ panel.hidden = true; backdrop.hidden = true; } }, 280);
    try { if (lastFocus && lastFocus.focus) lastFocus.focus(); else toggleBtn.focus(); } catch(e){}
  }
  function togglePanel(){ isOpen ? closePanel() : openPanel(); }

  /* ===== Focus trap (keeps Tab inside the dialog while open) ===== */
  function trapFocus(e){
    if (!isOpen || e.key !== 'Tab') return;
    var focusables = panel.querySelectorAll('button:not([disabled]), [href], textarea, input, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  }

  /* ===== Wire events ===== */
  toggleBtn.addEventListener('click', togglePanel);
  root.querySelector('[data-szc-close]').addEventListener('click', closePanel);
  backdrop.addEventListener('click', closePanel);
  sendBtn.addEventListener('click', function(){ sendMessage(input.value); });

  input.addEventListener('input', autoGrow);
  /* keep the field free of any autofill/extension tint ("box roxo") */
  killInputTint();
  input.addEventListener('focus', killInputTint);
  input.addEventListener('input', killInputTint);
  input.addEventListener('blur', killInputTint);
  try{ new MutationObserver(killInputTint).observe(input, { attributes:true, attributeFilter:['style'] }); }catch(e){}
  input.addEventListener('keydown', function(e){
    if (e.key === 'Enter' && !e.shiftKey){ e.preventDefault(); sendMessage(input.value); }
  });

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && isOpen){ closePanel(); }
    else { trapFocus(e); }
  });
})();
